import { render, staticRenderFns } from "./WorkTasksList.vue?vue&type=template&id=275a324a&scoped=true&"
import script from "./WorkTasksList.vue?vue&type=script&lang=js&"
export * from "./WorkTasksList.vue?vue&type=script&lang=js&"
import style0 from "./WorkTasksList.vue?vue&type=style&index=0&id=275a324a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a324a",
  null
  
)

export default component.exports